import styled from 'styled-components';

const MainWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export { MainWrapper };
